export const SITE_URL = "https://schmeitzdegroenailabs.com"

export const SITE_NAME = "Schmeitz De Groen AI Labs"

export const DEFAULT_OG_IMAGE = "/og_image.png"

/** Locales that have a fully crawlable URL space. */
export const HREFLANG_TAGS = {
  nl: "nl-NL",
  en: "en",
} as const

export const X_DEFAULT_LOCALE = "nl" as const
